/**
* @author ayou[beica1@outook.com]
* @date 2022/3/8 15:02
* @description
*   Header.vue of WeTrade
*/
<template>
<div class="flex-1 t-left">
  <Pic src="logo_&_text" width="120" height="32" />
</div>

<Pic src="head_phone" hegiht="16" width="16" />
<router-link to="/customerService">
  <t path="me_5" class="ml-4 c-title">Customer Service</t>
</router-link>

<span class="mx-16 c-tip">|</span>

<OnlyApp tag="button" class="btn line sm primary" @click="get">
  <Pic src="get_app" hegiht="16" width="16" class="v-middle" />
  Get more on WeTrade App
</OnlyApp>
</template>

<script lang="ts">
import Pic from '@/components/Pic.vue'
import { showAlert } from '@/components/popup/popup'
import OnlyApp from '@/provider/OnlyApp.vue'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'Header',
  components: { OnlyApp, Pic },
  setup () {
    return {
      get () {
        showAlert('jojo')
      },
    }
  },
})
</script>
